import { JobsOpportunitiesBanner } from 'components/JobsOpportunities/JobsOpportunitiesBanner';
import { ListJobs } from 'components/JobsOpportunities/ListJobs';
import { DNSEHead } from 'components/common/DNSEHead';
import RecruitmentLayout from 'layout';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { Toaster } from 'react-hot-toast';
import {
  getAllOpeningDepartment,
  getAllOpeningJobs,
  getRecommendSkills,
  getTotalNumberOpeningJobs
} from 'services/graphql/directus';
import { JobType } from 'types';
import { AppEnv } from 'utils/accessEnviroment';

import {
  Menu,
  NormalizeMenu,
  getRecruitmentMenusHeaderAndFooter
} from '@dnse/services';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useScrollPosition from '../../hooks/useScrollPosition';

interface PageProps {
  menusHeader: Menu[];
  menusFooter: NormalizeMenu;
  jobs: JobType[];
  totalNumberOpeningJobs: number;
  recommendSkills: string[];
  departments: string[];
}

const OpeningJobsPage = ({
  menusHeader,
  menusFooter,
  jobs,
  totalNumberOpeningJobs,
  recommendSkills,
  departments
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  useScrollPosition();
  return (
    <RecruitmentLayout menusHeader={menusHeader} menusFooter={menusFooter}>
      <DNSEHead
        title="Cơ hội việc làm tại DNSE"
        description="Khám phá các cơ hội việc làm tại DNSE với mức đãi ngộ hấp dẫn thuộc hàng TOP thị trường, đồng nghiệp siêu đỉnh, văn phòng xịn xò, ..."
      />
      <Toaster />
      <JobsOpportunitiesBanner
        totalNumberOpeningJobs={totalNumberOpeningJobs}
        recommendSkills={recommendSkills}
      />
      <ListJobs
        jobs={jobs}
        totalNumberOpeningJobs={totalNumberOpeningJobs}
        departments={departments}
      />
    </RecruitmentLayout>
  );
};

export const getStaticProps: GetStaticProps<PageProps> = async () => {
  const [
    getAllJobsRes,
    getMenusRes,
    totalNumberOpeningJobs,
    recommendSkills,
    departments
  ] = await Promise.all([
    getAllOpeningJobs(),
    getRecruitmentMenusHeaderAndFooter(),
    getTotalNumberOpeningJobs(),
    getRecommendSkills(),
    getAllOpeningDepartment()
  ]);

  return {
    props: {
      menusHeader: getMenusRes.menusHeader,
      menusFooter: getMenusRes.menusFooter,
      jobs: getAllJobsRes.jobs,
      totalNumberOpeningJobs,
      recommendSkills,
      departments
    },
    revalidate: AppEnv.REVALIDATE
  };
};

export default OpeningJobsPage;
